import React, { useContext } from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import { createWidget, updateWidget, deleteWidget } from '@/redux/actions';
import { CountdownContext } from '@/CountdownContextProvider';

const WS_WIDGETS_BY_HTTP = {
	CREATE_WIDGET: `widgets/POST`,
	UPDATE_WIDGET: `widgets/:widgetID/PATCH`,
	DELETE_WIDGET: `widgets/:widgetID/DELETE`,
};

const WidgetSubscriptions = props => {
	const {
		socket,
		children,
		currentEventId,
		widgets,
		createWidget,
		updateWidget,
		deleteWidget,
	} = props;

	const { countdownRef, setCountdown } = useContext(CountdownContext);
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribeToWidget = () => {
		socket.emit('event/widgets/:eventID/SUBSCRIBE', { eventID: currentEventId, widgets });
		console.log('⚡️ WidgetSubscriptions Mounted ⚡️');
	};

	const unsubscribeToWidget = () => {
		socket.emit('event/widgets/:eventID/UNSUBSCRIBE', { eventID: currentEventId, widgets });
		console.log(`🚶‍♂️ WidgetSubscriptions Unmounted 🚶‍♂️`);
	};

	const listenForCreatedWidget = () => {
		socket.on(WS_WIDGETS_BY_HTTP.CREATE_WIDGET, payload => {
			const { data, error } = payload;
			if (error) displayMessage(`widget could not be created`, error);
			else {
				const { createWidget: widget, index } = data;
				createWidget(widget, index);
				setCountdown(countdownRef.current - 1);
			}
		});
	};

	const listenForUpdatedWidget = () => {
		socket.on(WS_WIDGETS_BY_HTTP.UPDATE_WIDGET, payload => {
			const { data, error } = payload;
			if (error) displayMessage(`widget could not be updated`, error);
			else {
				updateWidget(data);
				setCountdown(countdownRef.current - 1);
			}
		});
	};

	const listenForDeletedWidget = () => {
		socket.on(WS_WIDGETS_BY_HTTP.DELETE_WIDGET, payload => {
			const { data, error } = payload;
			if (error) displayMessage(`widget could not be deleted`, error);
			else {
				const { deleteWidget: widget } = data;
				deleteWidget(widget.id);
				setCountdown(countdownRef.current - 1);
			}
		});
	};

	const listeners = () => [listenForCreatedWidget, listenForUpdatedWidget, listenForDeletedWidget];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribeToWidget}
				unsub={unsubscribeToWidget}
				listeners={listeners()}
				routes={Object.values(WS_WIDGETS_BY_HTTP)}
				from="widget"
			/>
			{React.cloneElement(children, propsToSend)}
		</>
	);
};

const msp = ({ ws, auth, events }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
	currentEventId: events.currentEvent.id,
});

const mdp = dispatch => ({
	createWidget: (widget, from) => dispatch(createWidget(widget, from)),
	updateWidget: (widget, from) => dispatch(updateWidget(widget, from)),
	deleteWidget: (widgetID, from) => dispatch(deleteWidget(widgetID, from)),
});

export default connect(msp, mdp)(WidgetSubscriptions);
